import React from 'react';
import { Form, Row, Col, Button } from 'antd';
import CouponRemoteSelect from './../../../components/Coupon/CouponRemoteSelect';
import BrandRemoteSelect from './../../../components/Brand/BrandRemoteSelect';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AppHomeForm extends React.Component {
    constructor() {
        super();
        this.state = {
            most_viewed: [],
            popularity: [],
            newest: [],
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({},fieldsValue));
        })
    }

    selectChanged = type => value =>  {
        this.props.form.setFieldsValue({ [type]: value });
        this.setState({
            [type]: value
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'ltr'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={20} offset={2}>
                    <FormItem
                    {...formItemLayout}
                    label="جدیدترین‌ها"
                    colon={false}>
                        {getFieldDecorator('newest', {
                            initialValue: this.props.initialData.newest,
                            rules: [
                                { required: true, message: 'انتخاب جدیدترین قرعه کشیها الزامی است.' },
                            ],
                        })(
                            <CouponRemoteSelect selectChanged={this.selectChanged.bind(this)('newest')} />
                        )}
                    </FormItem>
                    <FormItem
                    {...formItemLayout}
                    label="محبوب‌ترین‌ها"
                    colon={false}>
                        {getFieldDecorator('popularity', {
                            initialValue: this.props.initialData.popularity,
                            rules: [
                                { required: true, message: 'انتخاب جدیدترین قرعه کشیها الزامی است.' },
                            ],
                        })(
                            <CouponRemoteSelect  selectChanged={this.selectChanged.bind(this)('popularity')} />
                        )}
                    </FormItem>
                    <FormItem
                    {...formItemLayout}
                    label="پربازدیدترین‌ها"
                    colon={false}>
                        {getFieldDecorator('most_viewed', {
                            initialValue: this.props.initialData.most_viewed,
                            rules: [
                                { required: true, message: 'انتخاب پربازدید‌ترین قرعه کشیها الزامی است.' },
                            ],
                        })(
                            <CouponRemoteSelect  selectChanged={this.selectChanged.bind(this)('most_viewed')} />
                        )}
                    </FormItem>
                    <FormItem
                    {...formItemLayout}
                    label="برندهای محبوب"
                    colon={false}>
                        {getFieldDecorator('favorites_brands', {
                            initialValue: this.props.initialData.favorites_brands,
                            rules: [
                                { required: true, message: 'انتخاب برندهای محبوی الزامی است.' },
                            ],
                        })(
                            <BrandRemoteSelect  selectChanged={this.selectChanged.bind(this)('favorites_brands')}/>
                        )}
                    </FormItem>
                    </Col>
                </Row>
                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                        disabled={hasErrors(getFieldsError())}
                        style={{width: '10%', margin: '0px 45%'}}>
                         ثبت
                    </Button>
                </FormItem>
            </Form>
        </div>
        )
    }
}
AppHomeForm.defaultValue = {
    initialData: {}
}

export default Form.create({ name: 'app_home_setting' })(AppHomeForm);


// WEBPACK FOOTER //
// ./src/containers/Application/Home/form.js